module.exports = __webpack_public_path__ + "static/front-cover-c18b98564aa7cb5bd8b9859fcefb3d2d.jpg";